// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,
	app: {
		name: 'Firebase Toolkit',
		subtitle: 'Admin Portal',
		slogan: ''
	},
	// TODO: Replace the values for the keys that follow. Check the documentation.
	fire: {
		auth: {
			apiKey: 'AIzaSyCXv10kYJfVZQjrSzu4s7zNw7YcmZ_0QeE',
			authDomain: 'ionic-toolkit-firebase-play.firebaseapp.com',
			databaseURL: 'https://ionic-toolkit-firebase-play.firebaseio.com',
			storageBucket: 'ionic-toolkit-firebase-play.appspot.com',
			messagingSenderId: '725379216634'
		}
	},
	s3: {
		accessKeyId: 'AKIAJY6GD4REGAP7BPHQ',
		secretAccessKey: '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',
		bucket: 'dev.appseed.io/mobile-apps/businessdirectory-frb-admin'
	}
};



// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/environments/environment.ts